import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "line-tabs-2x"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#line-tabs-2x" }),
  /*#__PURE__*/_createTextVNode(" Line Tabs 2x ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Add "),
  /*#__PURE__*/_createVNode("code", null, ".nav-line-tabs-2x"),
  /*#__PURE__*/_createTextVNode(" class to us a line tab with 2px border width: ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createVNode("div", { class: "rounded border p-10" }, [
    /*#__PURE__*/_createVNode("ul", { class: "nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-5" }, [
      /*#__PURE__*/_createVNode("li", { class: "nav-item" }, [
        /*#__PURE__*/_createVNode("a", {
          class: "nav-link active",
          "data-bs-toggle": "tab",
          href: "#kt_tab_pane_4"
        }, "Link 1")
      ]),
      /*#__PURE__*/_createVNode("li", { class: "nav-item" }, [
        /*#__PURE__*/_createVNode("a", {
          class: "nav-link",
          "data-bs-toggle": "tab",
          href: "#kt_tab_pane_5"
        }, "Link 2")
      ]),
      /*#__PURE__*/_createVNode("li", { class: "nav-item" }, [
        /*#__PURE__*/_createVNode("a", {
          class: "nav-link",
          "data-bs-toggle": "tab",
          href: "#kt_tab_pane_6"
        }, "Link 3")
      ])
    ]),
    /*#__PURE__*/_createVNode("div", {
      class: "tab-content",
      id: "myTabContent"
    }, [
      /*#__PURE__*/_createVNode("div", {
        class: "tab-pane fade show active",
        id: "kt_tab_pane_4",
        role: "tabpanel"
      }, " Et et consectetur ipsum labore excepteur est proident excepteur ad velit occaecat qui minim occaecat veniam. Fugiat veniam incididunt anim aliqua enim pariatur veniam sunt est aute sit dolor anim. Velit non irure adipisicing aliqua ullamco irure incididunt irure non esse consectetur nostrud minim non minim occaecat. Amet duis do nisi duis veniam non est eiusmod tempor incididunt tempor dolor ipsum in qui sit. "),
      /*#__PURE__*/_createVNode("div", {
        class: "tab-pane fade",
        id: "kt_tab_pane_5",
        role: "tabpanel"
      }, " Nulla est ullamco ut irure incididunt nulla Lorem Lorem minim irure officia enim reprehenderit. Magna duis labore cillum sint adipisicing exercitation ipsum. Nostrud ut anim non exercitation velit laboris fugiat cupidatat. Commodo esse dolore fugiat sint velit ullamco magna consequat voluptate minim amet aliquip ipsum aute laboris nisi. Labore labore veniam irure irure ipsum pariatur mollit magna in cupidatat dolore magna irure esse tempor ad mollit. Dolore commodo nulla minim amet ipsum officia consectetur amet ullamco voluptate nisi commodo ea sit eu. "),
      /*#__PURE__*/_createVNode("div", {
        class: "tab-pane fade",
        id: "kt_tab_pane_6",
        role: "tabpanel"
      }, " Sint sit mollit irure quis est nostrud cillum consequat Lorem esse do quis dolor esse fugiat sunt do. Eu ex commodo veniam Lorem aliquip laborum occaecat qui Lorem esse mollit dolore anim cupidatat. eserunt officia id Lorem nostrud aute id commodo elit eiusmod enim irure amet eiusmod qui reprehenderit nostrud tempor. Fugiat ipsum excepteur in aliqua non et quis aliquip ad irure in labore cillum elit enim. Consequat aliquip incididunt ipsum et minim laborum laborum laborum et cillum labore. Deserunt adipisicing cillum id nulla minim nostrud labore eiusmod et amet. ")
    ])
  ])
], -1)
const _hoisted_5 = { class: "py-5" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`
        <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-5">
          <li class="nav-item">
            <a
              class="nav-link active"
              data-bs-toggle="tab"
              href="#kt_tab_pane_4"
              >Link 1</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link" data-bs-toggle="tab" href="#kt_tab_pane_5"
              >Link 2</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link" data-bs-toggle="tab" href="#kt_tab_pane_6"
              >Link 3</a
            >
          </li>
        </ul>
        `))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ])
  ]))
}